import { render, staticRenderFns } from "./Instrumentos.vue?vue&type=template&id=a56b41fc&scoped=true&"
import script from "./Instrumentos.vue?vue&type=script&lang=js&"
export * from "./Instrumentos.vue?vue&type=script&lang=js&"
import style0 from "./Instrumentos.vue?vue&type=style&index=0&id=a56b41fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56b41fc",
  null
  
)

export default component.exports